module.exports = __webpack_public_path__ + "static/media/workPvcCeilings1.6fdb0458.jpg";